// @flow
import {
  parsePhoneNumberFromString,
  type PhoneNumber,
} from 'libphonenumber-js';

export const formatPhoneNumber = (phoneNumberString: string): ?string => {
  const parsedPhoneNumber: ?PhoneNumber = parsePhoneNumberFromString(
    phoneNumberString,
    'US',
  );

  return parsedPhoneNumber && parsedPhoneNumber.formatNational();
};
